import {DRIVING_LICENSE_DURATIONS_NEEDING_LICENSE_DATE_LIST} from "@constants/dropdown-choices";
import {
   ADDITIONAL_DRIVING_QUALIFICATION_OPTIONS,
   DRIVING_LICENSE_DURATION_OPTIONS, DRIVING_LICENSE_TYPE_OPTIONS, DVLA_MEDICAL_CONDITION_OPTIONS,
   TITLE_OPTIONS,
   YES_NO_CHOICE_OPTIONS
} from "@constants/dropdown-choices";
import ObjetDataValidator from "@anjan011/object-data-validator";
import {transformValidationResultToArray} from "@utils/validation-markup-generator";
import {format} from "date-fns";
import {getTomorrowsDate} from "@utils/date-time";


export const ValidateStep2Data = (data) => {
   
   let nameMaxLen = 50;
   let nameAddressLen = 100;
   
   let titleValues = TITLE_OPTIONS?.map((item) => {
      return item.value
   });
   
   const rules = [
      {
         field_name: 'drivingLicenseType',
         field_label: 'Driving License Type',
         rules: [
            {name: 'required'},
            {name: 'string'},
            {
               name: 'in_array',
               data: {
                  array: DRIVING_LICENSE_TYPE_OPTIONS?.map((item) => item.value)
               },
               //message: 'Invalid driving license type: {value}'
            }
         ]
      },
      {
         field_name: 'provideDrivingLicenseNumber',
         field_label: 'Provide Driving License Number',
         rules: [
            {
               name: 'required_if_target_not_empty',
               data: {
                  target_field: 'drivingLicenseType'
               },
               message: 'Please specify if you want to provide your driving license number'
            },
            {name: 'string'},
         
         ]
      },
      {
         field_name: 'britishDrivingLicenseNumber',
         field_label: 'British Driving License Number',
         rules: [
            {
               name: 'required_if_target_equals',
               data: {
                  target_field: 'provideDrivingLicenseNumber',
                  value: 'Yes'
               },
               message: 'Please provide your British driving license number'
            },
            {name: 'string'},
            {
               name: 'exact_length',
               data: {length: 16},
               message: 'British driving license number must be exactly {data.length} characters long'
            },
         ]
      },
      {
         field_name: 'drivingLicenseDuration',
         field_label: 'Driving License Duration',
         rules: [
            {name: 'required'},
            {
               name: 'in_array',
               data: {
                  array: DRIVING_LICENSE_DURATION_OPTIONS?.map((item) => item.value)
               },
               message: 'Invalid driving license duration: {value}'
            },
         ]
      },
      {
         field_name: 'drivingLicenseDate',
         field_label: 'Driving license date',
         rules: [
            {
               name: 'required_if_target_in_array',
               data: {
                  target_field: 'drivingLicenseDuration',
                  array: DRIVING_LICENSE_DURATIONS_NEEDING_LICENSE_DATE_LIST,
               },
               message: 'Please provide your driving license date'
            },
            {
               name: 'date_string',
               data: {format: 'yyyy-MM-dd'},
               message: 'Invalid driving license date',
            },
            {
               name: 'date_string_before',
               data: {format: 'yyyy-MM-dd', date: format(getTomorrowsDate(), 'yyyy-MM-dd')},
               message: `Driving license date cannot be in the future`
            }
         ]
      },
      {
         field_name: 'dvlaMedicalConditions',
         field_label: 'DVLA Medical Conditions',
         rules: [
            {name: 'required'},
            {name: 'string'},
            {
               name: 'in_array',
               data: {array: DVLA_MEDICAL_CONDITION_OPTIONS?.map((item) => item.value)},
               message: `Invalid DVLA medical condition: {value}`
            }
         ]
      },
      
      {
         field_name: 'additionalDrivingQualifications',
         field_label: 'Additional Driving Qualifications',
         rules: [
            {name: 'nullable'},
            {name: 'string'},
            {
               name: 'in_array', data: {
                  array: ADDITIONAL_DRIVING_QUALIFICATION_OPTIONS?.map((item) => item.value)
               }
            }
         ]
      },
      {
         field_name: 'additionalDrivingQualificationDate',
         field_label: 'Additional Driving Qualification Date',
         rules: [
            {
               name: 'required_if_target_in_array',
               data: {
                  target_field: 'additionalDrivingQualifications',
                  array: ADDITIONAL_DRIVING_QUALIFICATION_OPTIONS
                  .filter((item) => {
                     return item.value !== '' && item.value !== 'No'
                  })?.map((item) => item.value),
               },
               message: 'Please provide the date of your additional driving qualification'
            },
            {
               name: 'date_string',
               data: {format: 'yyyy-MM-dd'},
               message: 'Invalid additional driving qualification date',
            },
            {
               name: 'date_string_before',
               data: {format: 'yyyy-MM-dd', date: format(getTomorrowsDate(), 'yyyy-MM-dd')},
               message: `Additional driving qualification date cannot be in the future {date}`
            }
         ]
      },
      {
         field_name: 'isBornInUk',
         field_label: 'Born in UK',
         rules: [
            {name: 'required'},
            {name: 'string'},
            {name: 'in_array', data: {array: YES_NO_CHOICE_OPTIONS?.map((item) => item.value)}}
         ]
      },
      {
         field_name: 'lastDateBecameUKResident',
         field_label: 'Born in UK',
         rules: [
            {
               name: 'required_if_target_equals',
               data: {
                  target_field: 'isBornInUk', value: 'No'
               },
               message: 'Please provide the last date you became a UK resident'
            },
            {
               name: 'string',
               message: `Invalid date value for last date of UK residency`
            },
            {name: 'date_string'},
            {
               name: 'date_string_before',
               data: {
                  date: format(getTomorrowsDate(), 'yyyy-MM-dd'),
               },
               message: `Last date of UK residency cannot be in the future`
            }
         ]
      },
      {
         field_name: 'hasNonMotoringCriminalConvictions',
         field_label: 'Non-Motoring Criminal Convictions',
         rules: [
            {
               name: 'required',
               message: `Please specify if you have any non-motoring criminal convictions`
            },
            {
               name: 'string',
            },
            {
               name: 'in_array',
               data: {array: YES_NO_CHOICE_OPTIONS?.map((item) => item.value)},
               message: `Please specify if you have any non-motoring criminal convictions`
            }
         ]
         
      },
      {
         field_name: 'nonMotoringCriminalConvictionsDetails',
         field_label: `Non-Motoring Criminal Convictions Details`,
         rules: [
            {
               name: 'required_if_target_equals',
               data: {
                  target_field: 'hasNonMotoringCriminalConvictions',
                  value: 'Yes'
               },
               message: `Please provide details on non-motoring criminal convictions`
            },
            {
               name: 'string',
            }
         ]
      }
   ];
   
   const validator = new ObjetDataValidator({
      data,
      rules
   });
   
   const result = validator.validate();
   
   if (result === true) {
      return [];
   } else {
      return transformValidationResultToArray(result);
   }
   
}